import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, mergeMap, of } from "rxjs";
import * as PurchaseReturnActions from "./purchase-return.actions";
import { PurchaseService } from "../../modules/transactions/purchase/purchase.service";

@Injectable()
export class PurchaseReturnEffects {
  constructor(
    private actions$: Actions,
    private api: PurchaseService
  ) {}

  loadPurchaseByTransaction$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PurchaseReturnActions.loadPurchaseByTransactionNo),
      mergeMap(({ payload }) =>{
        return this.api
          .getPurchaseByTransactionNo(
            payload.transactionNo,
            payload?.transactionDate || ""
          )
          .pipe(
            map((purchase) =>
              PurchaseReturnActions.loadPurchaseByTransactionNoSuccess({
                purchase,
              })
            ),
            catchError((error) =>
              of(
                PurchaseReturnActions.loadPurchaseByTransactionNoFailure({
                  error,
                })
              )
            )
          )
      }
      )
    )
  );

  loadSupplierPurchases$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PurchaseReturnActions.loadSupplierPurchases),
      mergeMap(({ supplierId, page, limit, financialYear }) =>
        this.api
          .getSupplierPurchases(supplierId, page, limit, financialYear)
          .pipe(
            map((res: any) =>
              PurchaseReturnActions.loadSupplierPurchasesSuccess({
                data: res.data,
                total: res.total,
                page,
              })
            ),
            catchError((error) =>
              of(PurchaseReturnActions.loadSupplierPurchasesFailure({ error }))
            )
          )
      )
    )
  );
}
